import { publish } from 'app/libs/core/PubSub';
import * as way from 'app/libs/core/PubSubWays';

const getCoefficient = (slider) => {
  let coefficient = slider / 100;
  coefficient **= 1.5;
  return coefficient;
};

const getSliderByCoefficient = (coefficient) => {
  const slider = coefficient ** (1 / 1.5);
  return slider * 100;
};

const isActiveSetting = (slider, is_random = true) => {
  return slider > 0 || !is_random;
};

const _isOnlyStartSet = (points) => {
  const count = [];
  points.forEach((point, i) => {
    if (point.lat) {
      count.push(i);
    }
  });

  return count.length === 1 && count[0] === 0;
};

const checkIfStartPointSetAutomatic = (parts, activeTab) => {
  const activePart = parts[activeTab - 1] || {};
  const activePoints = activePart.points ? activePart.points : [];
  const active = activePoints[0] || {};
  const prevPart = parts[activeTab - 2] || {};
  const prev = prevPart.points
    ? prevPart.points[prevPart.points.length - 1]
    : {};

  return (
    parts &&
    +activeTab > 0 &&
    _isOnlyStartSet(activePoints) &&
    active.lat === prev.lat &&
    active.lng === prev.lng
  );
};

const getFirstLastPoint = (points, last = true) => {
  if (
    last &&
    points[0]?.lat &&
    points[0]?.lng &&
    points[points.length - 1]?.lat &&
    points[points.length - 1]?.lng
  ) {
    return {
      first: { lat: points[0].lat, lng: points[0].lng },
      last: {
        lat: points[points.length - 1].lat,
        lng: points[points.length - 1].lng,
      },
    };
  }
  if (!last && points[0]?.lat && points[0]?.lng) {
    return {
      first: { lat: points[0].lat, lng: points[0].lng },
    };
  }
  return {};
};

const clearPoints = (cb) => {
  publish(way.DRIVE_CLEAR_DATA, { cb });
};

// const showRT = (obj) => {
//   publish(way.DRIVE_SHOW_RT_POLY, obj);
// };

const showRT = (e) => {
  const { waypoints = [] } = e;
  const points = [];
  waypoints.forEach((point) => {
    points.push({ lat: point.location[1], lng: point.location[0] });
  });

  publish(way.DRIVE_ADD_POINT_BY_FINGER_DRAW, {
    points,
    round: true,
  });
};

export const RTService = {
  getCoefficient,
  getSliderByCoefficient,
  isActiveSetting,
  getFirstLastPoint,
  showRT,
  clearPoints,
  checkIfStartPointSetAutomatic,
};
